import {
  CheckCircleIcon,
  XCircleIcon,
  ClockIcon,
  ExclamationTriangleIcon,
} from "@heroicons/react/24/outline";
import { ExecutionResultStatus } from "../../enums/TestLaunchEnums";

export const statusChipStyles = {
  Passed: {
    color: "#dcfce7",
    textColor: "#16a34a",
    borderColor: "#bbf7d0",
    icon: (
      <CheckCircleIcon className="icon" style={{ color: "#16a34a" }} />
    ),
    value: "passed",
  },
  Failed: {
    color: "#fee2e2",
    textColor: "#dc2626",
    borderColor: "#fecaca",
    icon: <XCircleIcon className="icon" style={{ color: "#dc2626" }} />,
    value: "failed",
  },
  Pending: {
    color: "#f3f4f6",
    textColor: "#64748b",
    borderColor: "#e5e7eb",
    icon: <ClockIcon className="icon" style={{ color: "#64748b" }} />,
    value: "pending",
  },
  Inprogress: {
    color: "#dbeafe",
    textColor: "#2563eb",
    borderColor: "#bfdbfe",
    icon: <ClockIcon className="icon" style={{ color: "#2563eb" }} />,
    value: "in_progress",
  },
  Aborted: {
    color: "#fef9c3",
    textColor: "#ca8a04",
    borderColor: "#fde68a",
    icon: (
      <ExclamationTriangleIcon
        className="icon"
        style={{ color: "#ca8a04" }}
      />
    ),
    value: "aborted",
  },
  "In Progress": {
    color: "#dbeafe",
    textColor: "#2563eb",
    borderColor: "#bfdbfe",
    icon: <ClockIcon className="icon" style={{  color: "#2563eb" }} />,
    value: "in_progress",
  },
  Completed: {
    color: "#dcfce7",
    textColor: "#16a34a",
    borderColor: "#bbf7d0",
    icon: (
      <CheckCircleIcon className="icon" style={{ color: "#16a34a" }} />
    ),
    value: "completed",
  },
  New: {
    color: "#f3f4f6",
    textColor: "#64748b",
    borderColor: "#e5e7eb",
    icon: <ClockIcon className="icon" style={{color: "#64748b" }} />,
    value: "new",
  },
  Paused: {
    color: "#f3f4f6",
    textColor: "#64748b",
    borderColor: "#e5e7eb",
    icon: <ClockIcon className="icon" style={{color: "#64748b" }} />,
    value: "paused",
  },
  Skipped: {
    color: "#fef9c3",
    textColor: "#ca8a04",
    borderColor: "#fde68a",
    icon: (
      <ExclamationTriangleIcon
        className="icon"
        style={{ color: "#ca8a04" }}
      />
    ),
    value: "skipped",
  }
};

export function formatStatusKey(value) {
  if (!value) return "";
  return value
    .toLowerCase()
    .replace(/_/g, " ") // replace underscores with spaces
    .replace(/\b\w/g, (char) => char.toUpperCase()); // capitalize each word
}

export const statusOptionsExecutionResult=[
  {value:ExecutionResultStatus.PASSED,label:formatStatusKey(ExecutionResultStatus.PASSED)},
  {value:ExecutionResultStatus.FAILED,label:formatStatusKey(ExecutionResultStatus.FAILED)},
  {value:ExecutionResultStatus.PENDING,label:formatStatusKey(ExecutionResultStatus.PENDING)},
  {value:ExecutionResultStatus.IN_PROGRESS,label:formatStatusKey(ExecutionResultStatus.IN_PROGRESS)},
  {value:ExecutionResultStatus.SKIPPED,label:formatStatusKey(ExecutionResultStatus.SKIPPED)}
]